import { css, LitElement, html } from "lit";
import { property, customElement } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let OfferCheckboxButton = class extends LitElement {
  constructor() {
    super(...arguments);
    this.checked = false;
  }
  change(e) {
    this.dispatchEvent(new Event(e.type, e));
  }
  render() {
    return html`
      <div class="checkbox-wrapper">
        <label for="checkbox-accept-offer">
          <input id="checkbox-accept-offer" type="checkbox" class="ui-checkbox" .checked=${this.checked} @change=${this.change}>
          <slot></slot>
        </label>
      </div>
  `;
  }
};
OfferCheckboxButton.styles = css`

    :host {
      flex: 1;
    }

    .checkbox-wrapper {
      display: flex;
    }

    .ui-checkbox {
      --primary-color: var(--default-vi-success-color);
      --secondary-color: #fff;
      --primary-hover-color: var(--default-vi-success-color);
      /* checkbox */
      --checkbox-diameter: 1.25rem;
      --checkbox-border-radius: 5px;
      --checkbox-border-color: var(--default-vi-border-color);
      --checkbox-border-width: 1px;
      --checkbox-border-style: solid;
      /* checkmark */
      --checkmark-size: 1.2;
    }
    
    .ui-checkbox, 
    .ui-checkbox *, 
    .ui-checkbox *::before, 
    .ui-checkbox *::after {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    
    .ui-checkbox {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      scale: var(--default-vi-action-checkbox-scale);
      width: var(--checkbox-diameter);
      height: var(--checkbox-diameter);
      border-radius: var(--checkbox-border-radius);
      background: var(--secondary-color);
      border: var(--checkbox-border-width) var(--checkbox-border-style) var(--checkbox-border-color);
      -webkit-transition: all 0.3s;
      -o-transition: all 0.3s;
      transition: all 0.3s;
      cursor: pointer;
      position: relative;
      margin: 0;
    }
    
    .ui-checkbox::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      -webkit-box-shadow: 0 0 0 calc(var(--checkbox-diameter) / 2.5) var(--primary-color);
      box-shadow: 0 0 0 calc(var(--checkbox-diameter) / 2.5) var(--primary-color);
      border-radius: inherit;
      opacity: 0;
      -webkit-transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
      -o-transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
      transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
    }
    
    .ui-checkbox::before {
      top: 40%;
      left: 50%;
      content: "";
      position: absolute;
      width: 4px;
      height: 7px;
      border-right: 2px solid var(--secondary-color);
      border-bottom: 2px solid var(--secondary-color);
      -webkit-transform: translate(-50%, -50%) rotate(45deg) scale(0);
      -ms-transform: translate(-50%, -50%) rotate(45deg) scale(0);
      transform: translate(-50%, -50%) rotate(45deg) scale(0);
      opacity: 0;
      -webkit-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),opacity 0.1s;
      -o-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),opacity 0.1s;
      transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6),opacity 0.1s;
    }
    
    /* actions */
    
    .ui-checkbox:hover {
      border-color: var(--primary-color);
    }
    
    .ui-checkbox:checked {
      background: var(--primary-color);
      border-color: transparent;
    }
    
    .ui-checkbox:checked::before {
      opacity: 1;
      -webkit-transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
      -ms-transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
      transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
      -webkit-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
      -o-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
      transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    }
    
    .ui-checkbox:active:not(:checked)::after {
      -webkit-transition: none;
      -o-transition: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      transition: none;
      opacity: 1;
    }

    label {
      display: flex;
      padding: var(--default-vi-action-checklist-item-padding);
      border-radius: var(--default-vi-action-border-radius);
      align-items: center;
      gap: 8px;
      font-family: var(--default-vi-font-family);
      font-size: var(--default-vi-font-md);
      cursor: pointer;
      flex: 1;
    }

    label:hover {
      background-color: rgba(0, 0, 0, 0.03);
    }

    @container (max-width: 600px) {
      label {
        align-items: flex-start;
      }

      .ui-checkbox {
        margin-top: 2px;
      }
    }

    @media (max-width: 600px) {
      label {
        align-items: flex-start;
      }

      .ui-checkbox {
        margin-top: 2px;
      }
    }
  `;
__decorateClass([
  property({ type: Boolean })
], OfferCheckboxButton.prototype, "checked", 2);
OfferCheckboxButton = __decorateClass([
  customElement("offer-checkbox-button")
], OfferCheckboxButton);
export {
  OfferCheckboxButton
};
